module.exports = __webpack_public_path__ + "static/media/logo_rev.d790e4f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_rev.svg
// module id = 176
// module chunks = 0